class NavigationMenu extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll('li.level-1').forEach((item) => {
      item.addEventListener('mouseenter', this.onEnter)
    })
    this.querySelectorAll('li.level-1').forEach((item) => {
      item.addEventListener('mouseleave', this.onLeave)
    })

    this.menuDrawerContainer = document.querySelector("#menu-drawer-container")
    this.menuDrawerOverlay = document.querySelector("#menu-drawer-overlay")
    this.menuDrawerContents = document.querySelector("#menu-drawer-contents")

    document.querySelector('#menu-drawer-button').addEventListener('click', this.toggleDrawer)
    document.querySelector('#menu-drawer-close-button').addEventListener('click', this.closeDrawer)
    this.menuDrawerOverlay.addEventListener('click', this.closeDrawer)

  }

  onEnter(event) {
    document.querySelector('predictive-search')?.closeSearch({ restoreFocus: false })

    let sub = event.currentTarget.querySelector('[data-menu-target]')
    if (!sub) return
    sub.classList.remove('invisible')

    // Hover menu trick by Hakim El Hattab
    // https://www.youtube.com/watch?v=o0NtjY17v5w&t=944s
    let container = event.currentTarget
    let button = container.querySelector('.hoverButton').getBoundingClientRect()
    let content = container.querySelector('.hoverContent').getBoundingClientRect()
    let path = container.querySelector('path')

    let header = document.querySelector('header')
    if (header.classList.contains('is_transparent')) {
      header.classList.remove('header_transparent')
    }

    path.setAttribute('d', `
    M ${button.x + button.width} ${button.height/2}
    Q ${button.x + button.width} ${content.y},
      ${content.width} ${content.y}
    H ${content.x}
    Q ${button.x} ${content.y},
      ${button.x} ${button.height/2}
    V ${button.height}
    H ${button.x + button.width}
    Z`)
    // End Hover menu trick
  }

  onLeave(event) {
    let header = document.querySelector('header')
    if (header.classList.contains('is_transparent')) {
      header.classList.add('header_transparent')
    }

    let sub = event.currentTarget.querySelector('[data-menu-target]')
    sub.classList.add('invisible')
    let container = event.currentTarget
    let path = container.querySelector('path')
    path.setAttribute('d', '')
  }

  toggleDrawer = event => {
    if (event) { event.preventDefault() }

    const isOpening = this.menuDrawerContainer.classList.contains('invisible')
    if (isOpening) {
      document.querySelector('predictive-search')?.closeSearch({ restoreFocus: false })
    }

    // Body
    document.body.classList.toggle('overflow-hidden')

    // Container
    this.menuDrawerContainer.classList.toggle('invisible')
    this.menuDrawerContainer.classList.toggle('pointer-events-none')

    // Overlay
    this.menuDrawerOverlay.classList.toggle('opacity-100')
    this.menuDrawerOverlay.classList.toggle('opacity-0')
    this.menuDrawerOverlay.classList.toggle('delay-200')

    // Contents
    this.menuDrawerContents.classList.toggle('left-0')
    this.menuDrawerContents.classList.toggle('-left-76')
  }

  closeDrawer = event => {
    if (event) { event.preventDefault() }

    // Body
    document.body.classList.remove('overflow-hidden')

    // Container
    this.menuDrawerContainer.classList.add('invisible')
    this.menuDrawerContainer.classList.add('pointer-events-none')

    // Overlay
    this.menuDrawerOverlay.classList.remove('opacity-100')
    this.menuDrawerOverlay.classList.add('opacity-0')
    this.menuDrawerOverlay.classList.add('delay-200')

    // Contents
    this.menuDrawerContents.classList.remove('left-0')
    this.menuDrawerContents.classList.add('-left-76')
  }


}

customElements.define('navigation-menu', NavigationMenu)